<template>
  <div
    class="setting-toggle-row"
    :class="{ 'setting-toggle-row--on': checked, 'setting-toggle-row--dense': dense }"
    role="switch"
    :aria-checked="checked ? 'true' : 'false'"
    tabindex="0"
    @click="toggle"
    @keydown.space.prevent="toggle"
    @keydown.enter.prevent="toggle"
  >
    <span class="setting-toggle-row__label">{{ $t(item.label) }}</span>
    <v-switch
      :input-value="checked"
      class="setting-toggle-row__switch"
      color="primary"
      inset
      hide-details
      readonly
      dense
    />
  </div>
</template>

<script>
import { isOn, onValue, offValue } from '../settingSchema'

export default {
  name: 'SettingToggleRow',
  props: {
    form: { type: Object, required: true },
    item: { type: Object, required: true },
    dense: { type: Boolean, default: false }
  },
  computed: {
    checked () {
      return isOn(this.form, this.item)
    }
  },
  methods: {
    toggle () {
      this.form[this.item.key] = this.checked ? offValue(this.item) : onValue(this.item)
    }
  }
}
</script>

<style scoped>
.setting-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 56px;
  padding: 6px 14px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s ease;
}
.setting-toggle-row--dense {
  min-height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.setting-toggle-row--dense.setting-toggle-row--on {
  border-color: rgba(25, 118, 210, 0.35);
  background: rgba(25, 118, 210, 0.04);
}
.theme--dark .setting-toggle-row--dense {
  border-color: rgba(255, 255, 255, 0.12);
}
.setting-toggle-row:hover {
  background: rgba(0, 0, 0, 0.03);
}
.setting-toggle-row:focus-visible {
  outline: 2px solid var(--v-primary-base, #1976d2);
  outline-offset: -2px;
}
.setting-toggle-row__label {
  font-size: 0.875rem;
  line-height: 1.5;
}
.setting-toggle-row__switch {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto;
  pointer-events: none;
}
</style>
